export default __webpack_public_path__ + "images/187ebc654e19d8044358d0cabb905f43-curve.svg";